import { defaultEnvironment, Footer } from '@environment/defaultEnvironment'

export const environment = {
  ...defaultEnvironment,
  backendBaseUrl: 'https://services-stage.covernet.de/services/customer-portal-scm/v1',
  favicon: 'scm.ico',
  clientId: 'customer-portal',
  realmId: 'scm',
  authUrl: 'https://sso.stage.covernet.de/auth',
  logo: 'scm.svg',
  customerStyleSheet: 'scm.css',
  customer: 'SCM Bundes-Verlag',
  company: 'SCM Bundes-Verlag gGmbH',
  backToShopLink: 'https://scm.ait.prod.cover-ecom.de/',
  onlineSubscriptionCustomTittle: 'Zugriff auf digitale Inhalte',
  onlineSubscriptionLink: [
    {
      label: 'App & Webapp',
      info: 'digitale Magazine & AllMag-Flat',
      url: 'https://shop.bundes-verlag.net/downloads-apps#app-info',
    },
    {
      label: 'Downloadportal Kinderkirche',
      info: 'SevenEleven und Kleine Leute Großer Gott',
      url: 'https://shop.bundes-verlag.net/downloads-apps#kigo-info',
    },
    {
      label: 'PDF-Ausgaben',
      info: 'Theologische beiträge, Zeit mit Gott, Zuversicht und Stärke',
      url: 'https://shop.bundes-verlag.net/pdf-downloads',
    },
  ],
  footer: {
    leftFooter: [
      {
        header: 'Über den SCM Bundes-Verlag',
        elements: [
          {
            type: 'link',
            textToDisplay: 'Kontakt',
            linkHref: 'https://shop.bundes-verlag.net/kontakt',
          },
          {
            type: 'link',
            textToDisplay: 'Vertrag beenden',
            linkHref: 'https://shop.bundes-verlag.net/vertrag-beenden',
          },
          {
            type: 'link',
            textToDisplay: 'AGB',
            linkHref: 'https://scm.ait.prod.cover-ecom.de/agb',
          },
          {
            type: 'link',
            textToDisplay: 'Datenschutz',
            linkHref: 'https://scm.ait.prod.cover-ecom.de/datenschutz',
          },
          {
            type: 'link',
            textToDisplay: 'Impressum',
            linkHref: 'https://scm.ait.prod.cover-ecom.de/impressum',
          },
          {
            type: 'link',
            textToDisplay: 'Erklärung zu Barrierefreiheit',
            linkHref: 'https://shop.bundes-verlag.net/erklarung-zu-barrierefreiheit',
          },
        ],
      },
    ],
    rightFooter: [
      {
        header: 'Kundenservice',
        elements: [
          {
            type: 'html',
            html: 'Telefon: <a href="tel:+49 (0)2302 930 93 910 ">+49 (0)2302 930 93 910</a> (Mo - Fr 8.00 - 17.00 Uhr)',
          },
          {
            type: 'html',
            html: 'E-Mail: <a href="mailto:vertrieb@bundes-verlag.de">vertrieb@bundes-verlag.de</a>',
          },
          {
            type: 'html',
            html: 'Shop: <a href="http://shop.bundes-verlag.net/" target="_blank">http://shop.bundes-verlag.net/</a>',
          },
        ],
      },
    ],
  } as Footer,
  sepaAgreement_de:
    'Ich ermächtige den SCM Bundes-Verlag (nachfolgend "Gläubiger") widerruflich, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die vom Gläubiger auf mein Konto gezogenen Lastschriften einzulösen.\n' +
    '\n' +
    'Ich bin damit einverstanden, dass der Gläubiger meine Daten (insbesondere Name, Kontonummer, Bankleitzahl) zum Zwecke der Durchführung der SEPA-Lastschrift und für die Abwicklung der Zahlungsvorgänge speichert.\n' +
    '\n' +
    'Mir ist bekannt, dass ich diese Einwilligung jederzeit widerrufen kann. Der Widerruf ist schriftlich an vertrieb@bundes-verlag.de zu richten. Ein Widerruf hat keine Auswirkungen auf bereits erfolgte Zahlungen, wirkt jedoch für die Zukunft.',
  sepaConditions_de:
    'Ich habe die Allgemeinen Geschäftsbedingungen sowie die Datenschutzerklärung der SCM Verlagsgruppe gelesen und stimme diesen ausdrücklich zu.',
  customerServiceEmail: 'vertrieb@bundes-verlag.de',
  customerServicePhone: '+49 (0)2302 930 93 910',
  translationFolder: 'scm',
  useCustomTranslation: true,
  features: {
    ...defaultEnvironment.features,
    complaint: true,
  },
}
